import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"350px"}
}

import {onMounted, ref, watch} from 'vue'
import FileUpload from "@/components/FileUpload.vue";
import {useApi} from "@/api/handler";
import {game} from "@/api";
import * as echarts from 'echarts';
import {ApiMap} from "@/api/type";


export default /*@__PURE__*/_defineComponent({
  __name: 'GradeRank',
  props: {
    gameId: {},
    data: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const chartRef = ref<HTMLDivElement | null>(null)
const props = __props

const emits = __emit
const GameStatus = ref<ApiMap['/game/status/:id']['resp']>(props.data)
const gradeRank = ref<ApiMap['/game/upload/chess']['resp'] | null>(null)

const useUploadGrade = (file: File) => {
  useApi({
    api: game.UploadGrade(props.gameId, file),
    onSuccess: async resp => {
      gradeRank.value = resp.data as ApiMap['/game/upload/chess']['resp']
      emits('update')
      renderChart()
    },
    tip: '成绩上传成功'
  })
}

const useGradeRank = () => {
  if (GameStatus.value.chessPhase === 0) return
  useApi({
    api: game.GradeRank(props.gameId),
    onSuccess: resp => {
      gradeRank.value = resp.data as ApiMap['/game/xxt/rank/:id']['resp']
      renderChart()
    }
  })
}

watch(() => props.data, newVal => {
  GameStatus.value = newVal
})

onMounted(() => {
  useGradeRank()
})

const renderChart = () => {
    if (!chartRef.value || !gradeRank.value) {
      return
    }
  const chart = echarts.init(chartRef.value);

  gradeRank.value.reverse()

  chart.setOption({
    grid: {
      top: 10,
      left: 10,
      bottom: 20,
      containLabel: true
    },
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        if (!gradeRank.value) return ''
        const data = gradeRank.value[params.dataIndex]
        return `
        <strong>${data.teamName}</strong><br/>
        得分：${data.thisRoundScore}<br/>
        提交时间：${data.submitTime}`
      }
    },
     xAxis: {
       type: 'value',
     },
     yAxis: {
       type: 'category',
       data: gradeRank.value.map(item => `第 ${item.teamId} 组`)
     },
     series: [{
       name: '得分',
       type: 'bar',
       data: gradeRank.value.map(item => item.thisRoundScore),
       label: {
         show: true,
         position: 'right'
       }
     }]
   })
}

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    rounded: "",
    class: "mt-3",
    height: "400px"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pa-4 bg-blue-lighten-1 text-lg-h6" }, "本回合答题排行榜", -1)),
      (GameStatus.value.chessPhase === 0 || !gradeRank.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FileUpload, {
              text: "上传答题数据",
              onUpload: useUploadGrade
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "pa-4",
        ref_key: "chartRef",
        ref: chartRef,
        style: {"width":"100%","height":"350px"}
      }, null, 512)
    ]),
    _: 1,
    __: [0]
  }))
}
}

})